"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSupplyDelete = void 0;
const Base_1 = require("./Base");
exports.PostSupplyDelete = {
    url: Base_1.URL_BASE + "/SupplyDelete",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSupplyDelete.js.map